import { PeriodProvider } from "@/providers/Period";
import { BreadcrumbProvider } from "@/providers/Breadcrumb";
import { ArrowsLeftRightIcon } from "@phosphor-icons/react";
import { lazy } from "react";

const MovimentacoesDashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.MovimentacoesDashboard })));
const ExtratoMovimentacaoTMC = lazy(() => import("./ExtratoTmc"));
const Gestao = lazy(() => import("./GestaoMovimentacao"));
const RelatorioMovimentacao = lazy(() => import("./RelatorioMovimentacao"));
const Acompanhamento = lazy(() => import("./Abastecimento/Abastecimento"));
const GestaoAbastecimento = lazy(() => import("./Abastecimento/AcompanhamentoAbatecimento"));

const Module = {
  menuItem: {
    to: "/movimentacoes",
    title: "Movimentações",
    icon: ArrowsLeftRightIcon,
    id: 10,
    childrens: [
      {
        to: "/movimentacoes/gestao",
        title: "Gestao",
        fullTitle: "Gestao",
        id: 22,
      },
      {
        to: "/movimentacoes/extrato-movimentacao-container",
        title: "Extrato Container",
        fullTitle: "Extrato Movimentação Container",
        id: 23,
      },
      {
        to: "/movimentacoes/relatorio-movimentacao",
        title: "Relatório de Movimentação",
        fullTitle: "Relatório de Movimentação",
        id: 24,
      },
      {
        to: "/movimentacoes/abastecimento-criar",
        title: "Criar Abastecimento",
        fullTitle: "Criar Abastecimento",
        id: 25,
      },
      {
        to: "/movimentacoes/abastecimento-gestao",
        title: "Gestão de Abastecimento",
        fullTitle: "Gestão de Abastecimento",
        id: 26,
      },
    ],
  },

  routes: [
    {
      path: "movimentacoes",
      element: <MovimentacoesDashboard />,
    },
    {
      path: "/movimentacoes/extrato-movimentacao-container",
      element: <ExtratoMovimentacaoTMC />,
    },
    {
      path: "/movimentacoes/gestao",
      element: (
        <PeriodProvider>
          <BreadcrumbProvider>
            <Gestao />
          </BreadcrumbProvider>
        </PeriodProvider>
      ),
    },
    {
      path: "/movimentacoes/relatorio-movimentacao",
      element: <RelatorioMovimentacao />,
    },
    {
      path: "/movimentacoes/abastecimento-criar",
      element: <Acompanhamento />,
    },
    {
      path: "/movimentacoes/abastecimento-gestao",
      element: (
        <PeriodProvider>
          <GestaoAbastecimento />
        </PeriodProvider>
      ),
    },
  ],
};

export default Module;
